import { render, staticRenderFns } from "./RelatorioPacienteAtendidos.vue?vue&type=template&id=1440e029&scoped=true"
import script from "./RelatorioPacienteAtendidos.vue?vue&type=script&lang=js"
export * from "./RelatorioPacienteAtendidos.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPacienteAtendidos.vue?vue&type=style&index=0&id=1440e029&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440e029",
  null
  
)

export default component.exports